import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import { errorColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { eventTypeMembershipsOrgInviteIdsSelector, eventTypeMembershipsUserIdsSelector, isHostSelectedSelector, isTouchedSelector } from '../../selectors';
import { List } from '../styles';
import { Participant } from './participant';
const loaderWrapperCss = "l1wpmujb";
const LoaderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(loaderWrapperCss, props.className)} />;
});
const wrapperCss = "w1znf6x";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const ParticipantsList = ({
  suggestions,
  isLoading,
  onRemove
}) => {
  const isHostSelected = useSelector(isHostSelectedSelector);
  const isTouched = useSelector(isTouchedSelector);
  const eventTypeMembershipUserIds = useSelector(eventTypeMembershipsUserIdsSelector);
  const eventTypeMembershipsOrgInviteIds = useSelector(eventTypeMembershipsOrgInviteIdsSelector);
  if (isLoading || suggestions.length === 0) {
    return <LoaderWrapper><Loader data-testid="loader" /></LoaderWrapper>;
  }
  const canRemove = suggestion => {
    if (suggestion.type === 'organization_membership') {
      return !eventTypeMembershipUserIds.includes(suggestion.entity.user_id);
    }
    return !eventTypeMembershipsOrgInviteIds.includes(suggestion.entity.id);
  };
  return <Wrapper>
      <BodyText weight="bold">{I18n.t('publisher.event_types.edit_permissions_modal.help_text')}</BodyText>
      {!isHostSelected && isTouched && <BodyText color={errorColor}>
          {I18n.t('publisher.event_types.edit_hosts_modal.no_host_error')}
        </BodyText>}
      <List scrollable={suggestions.length > 5}>
        {suggestions.map(suggestion => <Participant key={suggestion.id} participant={suggestion} canRemove={canRemove(suggestion)} onRemove={onRemove} />)}
      </List>
    </Wrapper>;
};

require("./participants_list.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./participants_list.js");